import { render } from "./NewFolder.vue?vue&type=template&id=48e318ec"
import script from "./NewFolder.vue?vue&type=script&lang=js"
export * from "./NewFolder.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__